import { inject, Injectable } from "@angular/core";
import { PlatformTypes } from "@app/models";
import { TranslocoService } from "@ngneat/transloco";
import { Observable, of } from "rxjs";
import { AdvancedAccountSetupFeature } from "../types/advanced-account-setup.types";
import { AdvancedAccountSetupGateService } from "./advanced-account-setup-gate.service";

const PROVISIONED_PLATFORMS: ReadonlyArray<PlatformTypes> = [PlatformTypes.TwoReward, PlatformTypes.SmsUSA, PlatformTypes.Vendasta];

export interface PlatformGatedFeature {
  platformId: number | null | undefined;
  icon?: string;
  open: () => void;
}

@Injectable({ providedIn: "root" })
export class PlatformAccountGateService {
  private readonly gateService = inject(AdvancedAccountSetupGateService);
  private readonly transloco = inject(TranslocoService);

  isProvisioned(platformId: number | null | undefined): platformId is PlatformTypes {
    return PROVISIONED_PLATFORMS.includes(platformId as PlatformTypes);
  }

  checkReady(feature: PlatformGatedFeature): Observable<boolean> {
    const { platformId } = feature;

    if (!this.isProvisioned(platformId)) {
      return of(true);
    }

    return this.gateService.checkReady({ kind: "platform", platform: platformId }, this.toSetupFeature(feature));
  }

  open(feature: PlatformGatedFeature): void {
    this.checkReady(feature).subscribe((ready) => {
      if (ready) {
        feature.open();
      }
    });
  }

  private toSetupFeature(feature: PlatformGatedFeature): AdvancedAccountSetupFeature {
    return {
      name: this.transloco.translate("advancedAccountSetup.platformName"),
      icon: feature.icon,
      open: feature.open
    };
  }
}
